import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
/**
 * The lifecycle methods owned by this provided are used to align internal
 * timings with those of the rbd lifecycle.
 *
 * The events are intentionally distinct to those exposed by rbd to avoid
 * any confusion around whether events are fired internally or externally
 * first.
 */

import React, { createContext, useCallback, useContext, useState } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies

import { combine } from '@atlaskit/pragmatic-drag-and-drop/combine';
import { batchUpdatesForReact16 } from '../utils/batch-updates-for-react-16';
import { rbdInvariant } from './rbd-invariant';

/**
 * The data associated with each type of lifecycle event.
 */

function createRegistry() {
  return {
    onPendingDragStart: [],
    onPrePendingDragUpdate: [],
    onPendingDragUpdate: [],
    onBeforeDragEnd: []
  };
}
function createLifecycleManager() {
  var registry = createRegistry();
  var addResponder = function addResponder(event, responder) {
    registry[event].push(responder);
    return function () {
      // @ts-expect-error - type narrowing issues
      registry[event] = registry[event].filter(function (value) {
        return value !== responder;
      });
    };
  };
  var dispatch = function dispatch(event, data) {
    batchUpdatesForReact16(function () {
      var _iterator = _createForOfIteratorHelper(registry[event]),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _responder = _step.value;
          _responder(data);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  };
  return {
    addResponder: addResponder,
    dispatch: dispatch
  };
}

/**
 * Creates a new lifecycle manager, returning methods for interfacing with it.
 */
export function useLifecycle() {
  var _useState = useState(createLifecycleManager),
    _useState2 = _slicedToArray(_useState, 1),
    lifecycleManager = _useState2[0];
  return lifecycleManager;
}
var LifecycleContext = /*#__PURE__*/createContext(null);
export function LifecycleContextProvider(_ref) {
  var children = _ref.children,
    lifecycle = _ref.lifecycle;
  /**
   * Allows for `<Draggable>` and `<Droppable>` instances to know about the
   * lifecycle timings.
   *
   * Designed to have a similar API to the pdnd monitors.
   */
  var monitorForLifecycle = useCallback(function (responders) {
    var cleanupFns = [];
    for (var _i = 0, _Object$entries = Object.entries(responders); _i < _Object$entries.length; _i++) {
      var entry = _Object$entries[_i];
      var _ref2 = entry,
        _ref3 = _slicedToArray(_ref2, 2),
        _event = _ref3[0],
        _responder2 = _ref3[1];
      cleanupFns.push(lifecycle.addResponder(_event, _responder2));
    }
    return combine.apply(void 0, cleanupFns);
  }, [lifecycle]);
  return /*#__PURE__*/React.createElement(LifecycleContext.Provider, {
    value: monitorForLifecycle
  }, children);
}
export function useMonitorForLifecycle() {
  var monitorForLifecycle = useContext(LifecycleContext);
  rbdInvariant(monitorForLifecycle !== null, 'useLifecycle() should only be called inside of a <DragDropContext />');
  return monitorForLifecycle;
}